import { SHOW_LOADER } from './../../actionTypes'

export const showLoader = () => {
  return { type: SHOW_LOADER }
}
